import React from "react";
import { experiences, earlierRoles } from "../../data/experience";
import { nodeId } from "../../data/connections";
import EvidenceCard from "../../components/investigation/EvidenceCard";
import CaseStamp from "../../components/investigation/CaseStamp";
import { detailFromExperience, detailFromPriorRecord } from "../../utils/evidenceDetail";

const entryNo = (index) => String(index + 1).padStart(2, "0");

const Employer = ({ role }) => (
  <span className="record-employer">
    {role.logo ? <img src={role.logo} alt="" loading="lazy" draggable="false" /> : null}
    {role.link ? (
      <a href={role.link} target="_blank" rel="noreferrer">
        {role.company}
      </a>
    ) : (
      role.company
    )}
  </span>
);

// A labelled blank on the form, filled in "by typewriter".
const Field = ({ label, children, className = "" }) => (
  <div className={`record-field ${className}`}>
    <dt>{label}</dt>
    <dd>{children}</dd>
  </div>
);

export const ExperienceSection = () => (
  <div className="experience-cluster">
    <div className="evidence-group">
      <p className="evidence-group-label">
        Records of employment <span>· newest first</span>
      </p>
      <ol className="timeline-row">
        {experiences.map((job, index) => (
          <li key={job.id}>
            <EvidenceCard
              variant="paper"
              pin={job.current ? "red" : index % 2 ? "brass" : "black"}
              rotate={index % 2 === 0 ? -0.7 : 0.9}
              className="record-card"
              nodeId={nodeId.job(job.id)}
              detail={detailFromExperience(job)}
            >
              <header className="record-card-head">
                <span>Form ER-02 · No. {entryNo(index)}</span>
                {job.current ? (
                  <CaseStamp tone="red" rotate={-6} className="tiny-stamp">
                    Current
                  </CaseStamp>
                ) : (
                  <span className="record-closed">Closed</span>
                )}
              </header>
              <dl className="record-fields">
                <Field label="Employer">
                  <Employer role={job} />
                </Field>
                <Field label="Position" className="record-field--typed">
                  {job.title}
                </Field>
                <Field label="Period">{job.duration}</Field>
                <Field label="Duties performed">
                  <ul className="timeline-bullets">
                    {job.bullets.map((bullet) => (
                      <li key={bullet}>{bullet}</li>
                    ))}
                  </ul>
                </Field>
                <Field label="Tools">{job.stack}</Field>
              </dl>
            </EvidenceCard>
          </li>
        ))}
        <li>
          <EvidenceCard
            variant="paper"
            pin="black"
            rotate={-1.1}
            className="record-card record-card--prior"
            detail={detailFromPriorRecord(earlierRoles)}
          >
            <header className="record-card-head">
              <span>Form ER-02 · Prior record</span>
              <span className="record-closed">2017–2018</span>
            </header>
            {earlierRoles.map((role, index) => (
              <dl key={role.id} className="record-fields">
                <Field label={`No. ${entryNo(experiences.length + index)} · Employer`}>
                  <Employer role={role} />
                </Field>
                <Field label="Position" className="record-field--typed">
                  {role.title}
                </Field>
                <Field label="Period">{role.duration}</Field>
              </dl>
            ))}
          </EvidenceCard>
        </li>
      </ol>
    </div>
  </div>
);

export default ExperienceSection;
